"use client";

import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Check } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MembershipTiersOverview() {
  const {
    ref: card1Ref,
    isVisible: card1Visible
  } = useRevealOnScroll({
    threshold: 0.25
  });
  const {
    ref: card2Ref,
    isVisible: card2Visible
  } = useRevealOnScroll({
    threshold: 0.25
  });
  const {
    ref: card3Ref,
    isVisible: card3Visible
  } = useRevealOnScroll({
    threshold: 0.25
  });
  const {
    ref: card4Ref,
    isVisible: card4Visible
  } = useRevealOnScroll({
    threshold: 0.25
  });
  const tiers = [{
    name: "Pathway 1",
    benefits: ["Access to association newsletter", "Member directory listing", "Annual general meeting invitation", "Basic networking opportunities"],
    ref: card1Ref,
    isVisible: card1Visible,
    delay: "delay-0"
  }, {
    name: "Pathway 2",
    benefits: ["All Basic Member benefits", "Continuing education discounts", "Event registration priority", "Professional development resources", "Collaboration platform access"],
    ref: card2Ref,
    isVisible: card2Visible,
    delay: "delay-100"
  }, {
    name: "Pathway 3",
    benefits: ["All Professional Member benefits", "Leadership opportunities", "Mentorship program participation", "Research collaboration access", "Recognition at association events", "Complimentary event admission"],
    ref: card3Ref,
    isVisible: card3Visible,
    delay: "delay-200"
  }, {
    name: "Associate Membership",
    benefits: ["Industry updates", "Networking events access", "Resource library", "Newsletter subscription"],
    ref: card4Ref,
    isVisible: card4Visible,
    delay: "delay-300"
  }];
  return <section id="membership-tiers-overview" className="py-16 !text-[hsl(213,27%,84%)] !bg-[hsl(213,27%,84%)] sm:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center">
          <h2 className="font-display text-3xl font-bold text-foreground sm:text-4xl lg:text-5xl">Membership</h2>
          <p className="mt-4 text-lg text-foreground/80">Choose the membership pathway that best reflects your professional background.</p>
        </div>

        <div className="grid gap-8 grid-cols-1 max-w-3xl mx-auto">
          {tiers.map((tier, i) => <div key={i} data-index={i} ref={tier.ref} className={`${tier.isVisible ? `animate-fade-in-up ${tier.delay}` : "opacity-0"}`}>
              <Card className="text-card-foreground gap-6 rounded-xl py-6 flex h-full flex-col shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] !bg-[hsl(210,40%,96%)] hover:-translate-y-1 hover:scale-[1.03] hover:shadow-strong">
                <CardHeader>
                  <CardTitle className="font-semibold text-2xl text-foreground !text-center">
                    {tier.name}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-1">
                  {i === 0 && <p className="text-base text-foreground/80 leading-relaxed">
                      Dentists who are on the principal register held by the Malta Medical Council and are included on a specialist register in any EU Member State.
                    </p>}
                  {i === 1 && <p className="text-base text-foreground/80 leading-relaxed">
                      Dentists who are on the principal register held by the Malta Medical Council and possess a Certificate of Completion of Specialist Training (CCST) or who have the training and qualifications to be eligible for inclusion on a specialist register in their respective dental specialty internationally
                    </p>}
                  {i === 2 && <p className="text-base text-foreground/80 leading-relaxed">
                      Dentists who are on the principal register held by the Malta Medical Council and possess (i) a post‑graduate degree in their respective dental specialty and (ii) a minimum of 10 years’ experience working full‑time within the specialty in a public service post or at an accredited state University, or equivalent.
                    </p>}
                  {i === 3 && <p className="text-base text-foreground/80 leading-relaxed">
                      Dentists who are on the principal register held by the Malta Medical Council and are undergoing specialty training or reading for a dental specialist degree that is recognised by the Board Of Administrators.
                    </p>}
                </CardContent>
                <CardFooter>
                  <Link to="#" className="w-full">
                    <Button className="w-full bg-primary text-foreground-primary hover:bg-primary-hover hover:scale-[1.03] hover:shadow-medium active:bg-primary-active focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
                      Join Now
                    </Button>
                  </Link>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}